import { BaseFeature, FeatureType } from '@core/shared/feature';
export class ConsoleBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/console/feature","featureId":"common-console"},
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'ConsoleFrontendSharedFeature',
        importFrom: 'frontend-shared'
      },
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'ConsoleFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'ConsoleFrontendSharedFeature',
        importFrom: 'frontend-shared'
      }
      // {forPlatform:'backend', type:FeatureType.Permanent, pluginClassName:'ConsoleBackendFeature'},
      // {forPlatform:'backend-admin', type:FeatureType.Permanent, pluginClassName:'ConsoleBackendAdminFeature'},
      ]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {}
      }
    };
  }
}